import { SidebarSearchModal } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';

const NON_CONFLUENCE_TYPES = ['software-catalog', 'techdocs'];

export const PortalSidebarSearchModal = () => {
  return (
    <SearchContextProvider
      initialState={{
        term: '',
        types: NON_CONFLUENCE_TYPES,
        filters: {},
      }}
    >
      <SidebarSearchModal />
    </SearchContextProvider>
  );
};
